export default "__VITE_ASSET__N_72vqWl__";